import { Observable, Subject } from 'rxjs';
import { read, WorkBook } from 'xlsx';
import { ISheet, ISpreadSheet } from '../interfaces/SheetInterfaces.interface';

export function getSheetsInSparsArraysFromFile(file: File): Observable<ISpreadSheet> {
    const fileReader = new FileReader();
    const spreadSheetSubject = new Subject<ISpreadSheet>();
    fileReader.onload = () => {
        const buffer = fileReader.result as ArrayBuffer;
        const workBook = read(buffer, {
            type: 'buffer',
            cellStyles: true, // Enable style parsing
            cellNF: true, // Enable number formats
            sheetStubs: true, // Include empty cells with formatting
            cellHTML: true, // Add this
            cellFormula: true, // Add this
            cellDates: true, // Add this
            raw: false, // Add this
        });
        const spreadSheet = getSheetsInSparsArrays(workBook);
        spreadSheetSubject.next(spreadSheet);
        spreadSheetSubject.complete();
    };
    fileReader.readAsArrayBuffer(file);
    return spreadSheetSubject.asObservable();
}

export function getSheetsInSparsArrays(workbook: WorkBook): ISpreadSheet {
    const regexp = /^([A-Z]+)(\d+)$/;

    const sheets: ISheet[] = Object.keys(workbook.Sheets).map((sheetName) => {
        let sheet: ISheet = {
            name: sheetName,
            rows: [],
            rawWorkbook: workbook,
        };
        const orgSheet = workbook.Sheets[sheetName];
        Object.keys(orgSheet).map((key) => {
            const match = regexp.exec(key);
            if (match != null) {
                // column
                const alphabeticPart = match[1];
                const alphabeticPartIndex = getAlphabeticPartIndex(alphabeticPart);
                // row
                const numericPart = match[2];
                // zero base the number
                const numericPartIndex = parseInt(numericPart, 10) - 1;

                sheet.rows[numericPartIndex] = sheet.rows[numericPartIndex] || {
                    cells: [],
                };

                // Fix: Handle undefined values properly
                const cellData = orgSheet[key];
                let cellValue = '';

                if (cellData && cellData.v !== undefined && cellData.v !== null) {
                    cellValue = `${cellData.v}`;
                }

                sheet.rows[numericPartIndex].cells[alphabeticPartIndex] = cellValue;
            }
        });
        return sheet;
    });

    return { sheets };
}

/**
 *
 * @param alphabeticPart a column index in excel  examples :"A", "AA", "D", "AAC" ...
 * @returns the zero based index of this column
 */
function getAlphabeticPartIndex(alphabeticPart: string) {
    let value = 0;
    // one based index
    const offset = 'A'.charCodeAt(0) - 1;
    for (const c of alphabeticPart) {
        value = value * 26 + (c.charCodeAt(0) - offset);
    }
    // convert to zero based index
    return value - 1;
}
